import CartaCorrecaoNFeService from "@/services/CartaCorrecaoNFeService";

export const cartaCorrecaoNFe = {
  namespaced: true,
  state: {
    cartacorrecaonfe: {},
  },
  actions: {
    getCartaCorrecaoNFe({ commit }, payload) {
      return CartaCorrecaoNFeService.GetCartaCorrecaoNFe(payload).then(
        (cartacorrecaonfe) => {
          return Promise.resolve(cartacorrecaonfe);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    postCartaCorrecaoNFe({ commit }, payload) {
      return CartaCorrecaoNFeService.PostCartaCorrecaoNFe(payload).then(
        (cartacorrecaonfe) => {
          return Promise.resolve(cartacorrecaonfe);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    putCartaCorrecaoNFe({ commit }, payload) {
      return CartaCorrecaoNFeService.PutCartaCorrecaoNFe(payload).then(
        (cartacorrecaonfe) => {
          return Promise.resolve(cartacorrecaonfe);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    deleteCartaCorrecaoNFe({ commit }, payload) {
      return CartaCorrecaoNFeService.DeleteCartaCorrecaoNFe(payload).then(
        (response) => {
          return Promise.resolve(response);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    getCartaCorrecaoNFeOData({ commit }, payload) {
      return CartaCorrecaoNFeService.GetCartaCorrecaoNFeOData(payload).then(
        (cartacorrecaonfe) => {
          return Promise.resolve(cartacorrecaonfe);
        },
        (error) => {
          return Promise.reject(error);
        }
      );
    },
  },
  mutations: {},
};

export default cartaCorrecaoNFe;
